import { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import uuid from 'uuid/v1'
import mapValues from 'lodash/mapValues'
import { selectAnalyticsParams } from '../../../store/site'
import { withRouter } from 'react-router'

class Analytics extends Component {
  componentDidMount () {
    if (this.shouldSendEvent(this.props)) this.sendTrackingEvent(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.shouldSendEvent(nextProps)) this.sendTrackingEvent(nextProps)
  }

  shouldSendEvent ({ track }) {
    return track === 'On'
  }

  sendTrackingEvent ({ sku, affiliation, router }) {
    const params = mapValues(router.location.query, (param) => decodeURIComponent(param))
    const donationUuid = params.origin && params.origin.split('/')[1]
    const { amount = 0 } = params

    const payload = {
      'transactionId': uuid(),
      'transactionAffiliation': affiliation || params.event_id,
      'transactionTotal': parseFloat(amount),
      'transactionTimestamp': Date.now(),
      'transactionFirstName': params.first_name,
      'transactionLastName': params.last_name,
      'transactionAnswer1': params.answer_1,
      'transactionAnswer2': params.answer_2,
      'transactionAnswer3': params.answer_3,
      'transactionProducts': [{
        'sku': sku || donationUuid,
        'name': 'Donation',
        'price': parseFloat(amount),
        'quantity': 1
      }],
      'event': 'DonationComplete'
    }

    window.dataLayer = window.dataLayer || []

    return window.dataLayer.push(payload)
  }

  render () {
    return null
  }
}

const mapStateToProps = (store) => selectAnalyticsParams(store)

export default compose(
  connect(mapStateToProps),
  withRouter
)(Analytics)



// WEBPACK FOOTER //
// ./components/utils/Analytics/index.js